import { ChannelTermNavigationNode } from './channel-term-navigation-node';
import { LanguageTermNavigationNode } from './language-term-navigation-node';
import { TermLabel } from './simplified-term';

export class NavigationNode {

  public Id: string;
  public Title: string;
  public Url: string;
  public Children: Array<NavigationNode | SPNavigationNode | WPNavigationNode>;

  constructor(opt?: Partial<NavigationNode | SPNavigationNode | WPNavigationNode>) {
    Object.assign(this, opt);
  }
}

export class SPNavigationNode extends NavigationNode {

  public Children: Array<SPNavigationNode>;

  // specific for Term Set navigation nodes
  public FriendlyUrl: string;
  public TermCount: number;
  public LastModified: Date;
  public Labels: Array<TermLabel>;
  public LocalCustomProperties: { [key: string]: string; };
  public Selected: boolean;
  public DisableSelection: boolean;
  public IsRoot: boolean;
  public IsAvailableForTagging: boolean;

  // specific for SP navigation nodes
  public IsDocLib: boolean;
  public IsExternal: boolean;
  public ParentId: number;
  public ListTemplateType: number;
  public AudienceIds?: any;

  /** UI specific, status for node expansion. */
  public Expanded?: boolean;

  constructor(opt?: Partial<SPNavigationNode>) {
    super();
    Object.assign(this, opt);
  }
}

export class WPNavigationNode extends NavigationNode {

  public Children: Array<WPNavigationNode>;
  public Order: number;
  public Parent?: WPNavigationNode;
  public ParentId?: number;
  public ChannelTermNavigationNodes: Array<ChannelTermNavigationNode>;
  public LanguageTermNavigationNodes: Array<LanguageTermNavigationNode>;

  constructor(opt?: Partial<WPNavigationNode>) {
    super();
    Object.assign(this, opt);
  }
}
